/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { CommentContainer_comment$ref } from "./CommentContainer_comment.graphql";
import { IgnoredTombstoneOrHideContainer_comment$ref } from "./IgnoredTombstoneOrHideContainer_comment.graphql";
import { ReplyListContainer1_comment$ref } from "./ReplyListContainer1_comment.graphql";
declare const _AllCommentsTabContainer_comment$ref: unique symbol;
export type AllCommentsTabContainer_comment$ref = typeof _AllCommentsTabContainer_comment$ref;
export type AllCommentsTabContainer_comment = {
    readonly id: string;
    readonly " $fragmentRefs": CommentContainer_comment$ref & ReplyListContainer1_comment$ref & IgnoredTombstoneOrHideContainer_comment$ref;
    readonly " $refType": AllCommentsTabContainer_comment$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "AllCommentsTabContainer_comment",
    "type": "Comment",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "CommentContainer_comment",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_comment",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_comment",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'f576259fdbd1b5053c372458203fdc4b';
export default node;
